import React from 'react';
import {HiExclamationTriangle} from 'react-icons/hi2';

interface RoadmapDeleteModalProps {
    showModal: boolean;
    projectName?: string;
    setShowModal: (showModal: boolean) => void;
    handleConfirm: any;
    isDeleting?: boolean;
}

const RoadmapDeleteModal = ({ projectName, setShowModal, showModal, handleConfirm, isDeleting = false }: RoadmapDeleteModalProps) => {
    const handleClose = () => {
        if (!isDeleting) {
            setShowModal(false);
        }
    }

    if (!showModal) return null;

    return (
        <div className="fixed inset-0 z-[9999] flex items-center justify-center p-4">
            {/* Backdrop */}
            <div 
                className="absolute inset-0 bg-black/50 dark:bg-black/70 backdrop-blur-sm" 
                onClick={handleClose}
            />
            
            {/* Modal */}
            <div className="relative bg-white dark:bg-gray-800 rounded-xl shadow-2xl border border-gray-200 dark:border-gray-700 p-6 mx-4 max-w-md w-full transform transition-all">
                {/* Icon */}
                <div className="flex items-center justify-center w-12 h-12 mx-auto mb-4 bg-red-100 dark:bg-red-900/30 rounded-full">
                    <HiExclamationTriangle className="w-6 h-6 text-red-600 dark:text-red-400" />
                </div>
                
                {/* Title */}
                <h3 className="text-lg font-semibold text-gray-900 dark:text-white text-center mb-2">
                    Delete Work Item
                </h3>
                
                {/* Description */}
                <p className="text-sm text-gray-600 dark:text-gray-300 text-center mb-6">
                    Are you sure you want to delete {projectName ? `"${projectName}"` : 'this work item'}? This action cannot be undone.
                </p>
                
                {/* Buttons */}
                <div className="flex gap-3 justify-end">
                    <button
                        onClick={handleClose}
                        disabled={isDeleting}
                        className={`px-4 py-2 text-sm font-medium rounded-lg transition-colors ${
                            isDeleting 
                                ? 'text-gray-400 bg-gray-100 dark:bg-gray-700 dark:text-gray-500 cursor-not-allowed' 
                                : 'text-gray-700 dark:text-gray-300 bg-white dark:bg-gray-700 border border-gray-300 dark:border-gray-600 hover:bg-gray-50 dark:hover:bg-gray-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-500 dark:focus:ring-gray-400'
                        }`}
                    >
                        Cancel
                    </button>
                    <button
                        onClick={handleConfirm}
                        disabled={isDeleting}
                        className={`px-4 py-2 text-sm font-medium text-white rounded-lg transition-all duration-200 flex items-center justify-center min-w-[80px] ${
                            isDeleting 
                                ? 'bg-red-600 cursor-not-allowed opacity-80' 
                                : 'bg-red-600 hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500 dark:focus:ring-red-400 opacity-100'
                        }`}
                    >
                        {isDeleting ? (
                            <>
                                <svg className="animate-spin -ml-1 mr-2 h-4 w-4" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                                    <circle className="opacity-25" cx="12" cy="12" r="10" stroke="white" strokeWidth="4"></circle>
                                    <path className="opacity-75" fill="white" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                                </svg>
                                <span className="text-white">Deleting...</span>
                            </>
                        ) : (
                            'Delete'
                        )}
                    </button>
                </div>
            </div>
        </div>
    )
}

export default RoadmapDeleteModal; 